import { DBCollection } from '@/lib/utils/constants-shared';
import type { Firestore } from 'firebase/firestore';
import { collection, getDocs } from 'firebase/firestore';

import { fetchCollectionFromStorage } from '@/lib/utils/storage-bulk-data';
import type { FirebaseStorage } from 'firebase/storage';

/**
 * Fetch archaeology by passage from DB (Storage first, then Firestore)
 */
export async function fetchArchaeologyByPassageFromDB(
  auth: any,
  db: Firestore,
  storage?: FirebaseStorage
): Promise<ArchaeologyByPassage[]> {
  const fallback = async () => {
    const archaeologyByPassageRef = collection(db, DBCollection.archaeologyByPassage);
    const snapshot = await getDocs(archaeologyByPassageRef);

    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      dateCreated: doc.data().dateCreated?.toDate(),
      dateUpdated: doc.data().dateUpdated?.toDate()
    })) as ArchaeologyByPassage[];
  };

  if (storage) {
    return await fetchCollectionFromStorage<ArchaeologyByPassage>(
      storage,
      `bulk-data/${DBCollection.archaeologyByPassage}.json`,
      fallback
    );
  }

  return await fallback();
}

